import * as angular from 'angular';

export const SignInTitleComponent: angular.IComponentOptions = {
  controller: class {
    static $inject = [];
    public avatar: any;
  },
  controllerAs: 'ctrl',
  bindings: {
    avatar: '<',
  },
  template: `
  <div class="sign-in-title">
    <div ng-if="ctrl.avatar" class="avatar-container">
      <mode-avatar options="ctrl.avatar" size="75"></mode-avatar>
    </div>
    <capra-icon
      ng-if="!ctrl.avatar"
      class="sign-in-logo"
      icon="illo-mode-logo-emblem"
      width="72px"
      height="72px"
    ></capra-icon>
    <h1 class="sign-in-to-mode">Sign in to Mode</h1>
  </div>
  `,
};
